import type {AxiosRequestConfig} from 'axios';
import {Package} from './interface';

export class GetAllPackagesRequestBuilder {
  private readonly packagesRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/packages',
    params: {},
  };

  id(id: string) {
    this.packagesRequest.url = `/packages/${id}`;
    return this;
  }

  params(params: object) {
    this.packagesRequest.params = params;
    return this;
  }

  build() {
    return this.packagesRequest;
  }
}

export class GetAllPackageTypesRequestBuilder {
  private readonly packagesRequest: AxiosRequestConfig = {
    method: 'GET',
    url: `/packages/type`,
    params: {},
  };

  params(params: object) {
    this.packagesRequest.params = params;
    return this;
  }

  build() {
    return this.packagesRequest;
  }
}

export class GetPackagesCountRequestBuilder {
  private readonly packagesRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/packages/count',
    params: {},
  };

  params(params: object) {
    this.packagesRequest.params = params;
    return this;
  }

  build() {
    return this.packagesRequest;
  }
}

export class GetPackagesCountOrdersRequestBuilder {
  private readonly packagesRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/packages/count-order',
    params: {},
    data: {},
  };

  params(params: object) {
    this.packagesRequest.params = params;
    return this;
  }
  
  data(data: number[]) {
    this.packagesRequest.data = data;
    return this;
  }

  build() {
    return this.packagesRequest;
  }
}

export class GetPackageReportOrderListRequestBuilder {
  private readonly packageRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '',
    params: {},
  }

  params(params: object) {
    this.packageRequest.params = params;
    return this;
  }

  id(id: number){
    this.packageRequest.url = `/packages/${id}/orders`;
    return this;
  }

  build() {
    return this.packageRequest;
  }
  
}

export class ExportPackagesFileRequestBuilder {
  private readonly packagesRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/packages/file',
    params: {},
  };

  params(params: object) {
    this.packagesRequest.params = params;
    return this;
  }

  build() {
    return this.packagesRequest;
  }
}

export class ReportPackagesRequestBuilder {
  private readonly packagesRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/packages/report',
    params: {},
  };

  params(params: object) {
    this.packagesRequest.params = params;
    return this;
  }

  build() {
    return this.packagesRequest;
  }
}

export class GetPackageStatusRequestBuilder {
  private readonly packagesRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '',
    params: {},
  };

  id(id: string) {
    this.packagesRequest.url = `/packages/${id}/status`;
    return this;
  }

  params(params: object) {
    this.packagesRequest.params = params;
    return this;
  }

  build() {
    return this.packagesRequest;
  }
}

export class GetAllSuggestedPackagesforOrder {
  private readonly packagesRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '',
  };

  id(id: string) {
    this.packagesRequest.url = `/packages/suggest/${id}`;
    return this;
  }

  build() {
    return this.packagesRequest;
  }
}

export class CreatePackagesRequestBuilder {
  private readonly packagesRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/packages',
    data: {},
  };

  data(data: Package) {
    this.packagesRequest.data = data;
    return this;
  }

  build() {
    return this.packagesRequest;
  }
}

export class UpdatePackageRequestBuilder {
  private readonly packagesRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/packages',
    data: {},
  };

  data(body: Package) {
    this.packagesRequest.data = body;
    return this;
  }

  build() {
    return this.packagesRequest;
  }
}

export class UpdatePackageStatusRequestBuilder {
  private readonly packagesRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/packages/status',
    data: {},
  };

  data(body: Package) {
    this.packagesRequest.data = body;
    return this;
  }

  build() {
    return this.packagesRequest;
  }
}

export class UpdatePackageStatusesRequestBuilder {
  private readonly packagesRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '',
    data: {},
  };

  id(id: string) {
    this.packagesRequest.url = `/packages/${id}/status`;
    return this;
  }

  data(body: Package) {
    this.packagesRequest.data = body;
    return this;
  }

  build() {
    return this.packagesRequest;
  }
}
